import { render } from "./BucketList.vue?vue&type=template&id=11aea084&scoped=true"
import script from "./BucketList.vue?vue&type=script&lang=js"
export * from "./BucketList.vue?vue&type=script&lang=js"

import "./BucketList.vue?vue&type=style&index=0&id=11aea084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11aea084"]])

export default __exports__